import { render, staticRenderFns } from "./ShippingInsurancesHead.vue?vue&type=template&id=1118169e&scoped=true"
import script from "./ShippingInsurancesHead.vue?vue&type=script&lang=js"
export * from "./ShippingInsurancesHead.vue?vue&type=script&lang=js"
import style0 from "./ShippingInsurancesHead.vue?vue&type=style&index=0&id=1118169e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1118169e",
  null
  
)

export default component.exports